<template>
  <div class="messages content">
    <div class="messages__header">
      <Row type="flex" align="middle" :gutter="30">
        <Col><h3 class="is-title">Сообщения</h3></Col>
        <Col>
          <v-tag rounded color="gray" :text="unreadMessages.length" />
        </Col>
      </Row>
    </div>
    <list-header align="middle" type="messages" />
    <user-card
      type="messages"
      v-for="(item, index) in filteredChats"
      :key="index"
      :data="item"
    />
  </div>
</template>

<script>
//import ChatService from "@/services/ChatService";
import AppointmentService from "@/services/AppointmentService";
import UserCard from "@/components/UserCard";
import ListHeader from "@/components/ListHeader";
import VTag from "@/components/VTag";
import loadingMixin from "../mixins/loadingMixin";
import MessagesService from "@/services/MessagesService";
export default {
  name: "Messages",
  components: {
    UserCard,
    ListHeader,
    VTag
  },
  mixins: [loadingMixin],
  data() {
    return {
      //chatService: new ChatService(),
      appointmentService: new AppointmentService(),
      messages: [],
      chats: []
    };
  },
  computed: {
    unreadMessages() {
      return this.messages.length > 0
        ? this.messages.filter(el => el.unread)
        : [];
    },
    filteredChats() {
      return this.chats.length > 0
        ? [...this.chats].sort((a, b) => b.created - a.created)
        : [];
    }
  },
  async created() {
    this.loading = true;
    await this.initChats();
    this.loading = false;
  },
  methods: {
    async initChats() {
      await this.appointmentService.getAppointmentsAll();
      this.messages = await MessagesService.getMessages();
      let chats = MessagesService.getGroupedByAppointmentMessages(
        this.messages
      );

      if (chats) {
        for (let item in chats) {
          // let apt = appointments.find(el => el.id===chats[item][0].appointment);
          // apt.setChat(chats[item])
          //  console.log(apt.chat.formatToChatList())
          this.chats.push(this.formatChatItem(chats[item]));
        }
      }
    },
    formatChatItem(chat) {
      let appointment = this.appointmentService.appointments.find(
        el => el.id === chat[0].appointment
      );
      appointment.setChat(chat);
      return appointment.chat.formatToChatList();
      // if (appointment) {
      //   return {
      //     ...chat,
      //     notary: appointment.notary,
      //     client: appointment.client
      //   };
      // }
    },
    getUnreadMessagesFromChat(chat) {
      return chat.filter(el => el.unread);
    }
  }
};
</script>

<style scoped lang="scss">
.messages {
  padding: 50px 40px;
  box-sizing: border-box;
  min-height: 940px;
  &__header {
    margin-bottom: 40px;
  }
}
</style>
